import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import type ViewProductStore from '../../AppData/_stores/ViewProductStore';
import type { ProductCatalogCollection } from './ProductCatalogCollection';

const compareNullableOrder = (aOrder: number | null, bOrder: number | null) => {
  if (aOrder === bOrder) return 0;
  if (aOrder === null) return 1;
  if (bOrder === null) return -1;
  return aOrder - bOrder;
}

const compareBestsellerProducts = (a: ViewProductStore, b: ViewProductStore) => {
  const bestsellerOrder = compareNullableOrder(a.get('bestseller_order'), b.get('bestseller_order'));
  if (bestsellerOrder !== 0) return bestsellerOrder;

  return b.get('id') - a.get('id');
}

const bestsellersCollection: ProductCatalogCollection = {
  compareProducts: compareBestsellerProducts,
  description: t => t('Browse customer favorites and popular starting points for print-on-demand products.'),
  matchesProduct: product => product.get('bestseller_order') !== null,
  navIcon: WorkspacePremiumRoundedIcon,
  navTone: 'bestseller',
  slug: 'bestsellers',
  title: t => t('Bestsellers'),
};

export default bestsellersCollection;
